module.exports = __webpack_public_path__ + "static/img/11.5e23236b.jpg";